import store from './data';
import moment from "moment";
import router from "./../routes";

export default {
    postData: {
        delivery_type: [],
        delivery_address: null,
        pick_up_address: null,
        services: [],
        payment_type: null,
        items: null,
        common_price: null,
        common_discount: null,
        final_price: null,
        delivery_note: null,

        delivery_outside: '1',
        delivery_outside_distance: null,
        pick_up_outside: '1',
        pick_up_outside_distance: null,
        email: null
    },

    delivery_type: [],
    delivery_address: {
        city: null,
        // street: null,
        // house: null,
        // building: null,
        // apartment: null,
    },

    pick_up_address: {
        city: null,
        // street: null,
        // house: null,
        // building: null,
        // apartment: null,
    },

    state: {
        step: 1,
        confirm: false,
        pick_up_as_delivery: false,
        loading: false,
        link_pdf: null,

        discount_period: 0,
        discount_personal: 0,

        email_valid: true,
        email_error: false,
    },

    /*******/

    updateData() {
        this.postData = {
            delivery_type: [],
            delivery_address: null,
            pick_up_address: null,
            services: [],
            payment_type: null,
            items: null,
            common_price: null,
            common_discount: null,
            final_price: null,
            delivery_note: null,

            delivery_outside: '1',
            delivery_outside_distance: null,
            pick_up_outside: '1',
            pick_up_outside_distance: null,
            email: null
        };
        this.delivery_address = {
            city: null,
            // street: null,
            // house: null,
            // building: null,
            // apartment: null,
        };
        this.pick_up_address = {
            city: null,
            // street: null,
            // house: null,
            // building: null,
            // apartment: null,
        };

        this.state.confirm = false;
        this.state.pick_up_as_delivery = false;
    },

    sendOrder(set_discount) {
        this.state.link_pdf = null;
        this.state.loading = true;
        let data = this.postData;

        this.delivery_type.forEach(item => {
            if (item == '60129542270') data.delivery_address = this.delivery_address;
            if (item == '60129542271') data.pick_up_address = this.pick_up_address;
        });
        let delivery_type = [];
        this.postData.delivery_type.forEach(item => {
            let data = {
                id: item.id,
                name: item.f1
            };
            delivery_type.push(data)
        });
        data.delivery_type = delivery_type;

        if(this.postData.services && this.postData.services.length > 0) {
            let items = [];
            this.postData.services.forEach(item => {
                items.push(item.id)
            });
            data.services = items;
        }

        if(this.state.pick_up_as_delivery) {
            data.pick_up_address = this.delivery_address;
            if(data.delivery_outside_distance) data.pick_up_outside_distance = data.delivery_outside_distance;
            data.delivery_outside = data.pick_up_outside;
        }

        data.common_price = store.common_price.price;
        data.common_discount = store.common_price.discount_price;
        data.final_price = data.common_price - data.common_discount;

        // const dates = JSON.parse(store.getItemlocalStorage('chosen-dates'));
        // const time = JSON.parse(store.getItemlocalStorage('chosen-time'));

        const timeStart = {hour: store.state.timeStart.HH, minute: store.state.timeStart.mm, second: 0, millisecond: 0};
        const timeEnd = {hour: store.state.timeEnd.HH, minute: store.state.timeEnd.mm, second: 0, millisecond: 0};

        const dates = {
            from: moment(store.state.dates.start).set(timeStart).format('DD.MM.YYYY HH:mm'),
            to: moment(store.state.dates.end).set(timeEnd).format('DD.MM.YYYY HH:mm')
        };

        data.booked_from = dates.from;
        data.booked_until = dates.to;
        console.log(store.state.basket_items, 'store.state.basket_items')
        if (set_discount === 'set_discount') {
            console.log('aaaaaaaaaaaaa')
            let set_item_discount = store.state.basket_items;
            set_item_discount.forEach(item => {
                if (item.discount_flag == 0 && item.promoCodeId == null) {
                    item.discount = store.common_price.discount;
                    item.common_discount = item.common_price * store.common_price.discount / 100;
                    item.finally_price = item.common_price - item.common_discount;
                }
            });
            data.items = set_item_discount;
        }
        else {
            console.log('bbbbbbbbbbbbbbbbb')
            data.items = store.state.basket_items;
        }
        data.discount = store.common_price.discount;

        console.log(data.items, 'data.items');

        // data.services = Object.assign({}, this.postData.services);

        let url = '/api/save-order';
        const options = {
            headers: {Authorization: "Bearer " + localStorage.getItem('token')},
        };

        axios.post(url, data, options)
            .then(response => {
                if (response.status == 200) {
                    this.state.link_pdf = response.data.link_pdf;

                    store.removeItemLocaleStorage('promoCodes');
                    store.removeItemLocaleStorage('chosen-products');
                    store.state.basket_count = null;
                    this.updateData();

                    this.postData.delivery_type = [];
                    this.delivery_type = [];


                    this.postData.delivery_outside_distance = null;
                    this.postData.delivery_outside = '1';

                    this.postData.pick_up_outside_distance = null;
                    this.postData.pick_up_outside = '1';

                    router.push( { path: 'basket/thank-you-page'} );

                    this.state.loading = false;
                    this.state.step = 1;
                }
            })
            .catch(error => {
                if(error) this.state.loading = false;
            })
    },

    echoDate(date) {
        //var d = new Date(dateString.replace(/-/g, '/'));

        // let jsDate = new Date(date.replace(' ', 'T'));
        // let day = jsDate.getDate();
        // if(day < 10) day = '0' + day;
        // let month = 1 + jsDate.getMonth();
        // if(month < 10) month = '0' + month;
        // let year = jsDate.getFullYear();
        //
        // return day + '.' + month + '.' + year;
        return moment(date).format('DD.MM.YYYY');
    },

    echoDateTime(date) {
        return moment(date).format('DD.MM.YYYY HH:mm');
        // let days = this.echoDate(date.replace(' ', 'T') + "Z");
        // let jsTime = new Date(date);
        // let hours = jsTime.getHours();
        // let minutes = jsTime.getMinutes();
        //
        // if(minutes < 10) minutes = '0' + minutes;
        //
        // return days + ' ' + hours + ':' + minutes;
    }

}
